const CogCredits = Backbone.View.extend({
    el: $(document),

    events: {
        "click .cog-credits__toggle": "connectedCallback",
    },

    initialize: function () {
        this.render();
    },
    connectedCallback: function(e) {
        const status = $(".cog-credits").hasClass("open");
        $(".cog-credits")[`${!status ? 'add' : 'remove'}Class`]("open");
    },
    render: function () {
    },
});

export default CogCredits;
